<template>
  <b-card>
    <b-row>
      <b-col md="4">
        <b-input-group>
          <b-form-input
            v-model="filter"
            type="search"
            id="filterInput"
            placeholder="Type to Search"
            class="input-new"
          ></b-form-input>
          <b-input-group-append>
            <b-button :disabled="!filter" @click="filter = ''">x</b-button>
          </b-input-group-append>
        </b-input-group>
      </b-col>
    </b-row>
    <!-- TABLE -->

    <b-table
      show-empty
      head-variant="dark"
      striped
      hover
      bordered
      :items="items"
      :fields="fields"
      :per-page="perPage"
      :current-page="currentPage"
      :filter="filter"
      :filterIncludedFields="filterOn"
      @filtered="onFiltered"
    >
      <template v-slot:cell(suboutlet)="data">
        <span v-for="(outlet, index) in data.value" :key="index">
          <b-row>
            <b-col sm="7" >
              <span>{{ outlet.name }}</span>
            </b-col>
            <b-col sm="1">
              <b-link @click="onEditSub(outlet, 'editSub', data.item)"><i class="ti-pencil-alt" style="font-size:20px;"></i></b-link>
            </b-col>
            <b-col sm="1">
              <b-link @click="onClickDeleteSub(outlet.id)"><i class="ti-trash" style="font-size:20px;"></i></b-link>
            </b-col>
          </b-row>
        </span>
      </template>
      <template v-slot:cell(typeoutlet)="data">
        <span v-for="(type, index) in data.value" :key="index">
          <b-row>
            <b-col sm="7" >
              <span>{{ type.name }}</span>
            </b-col>
            <b-col sm="1">
              <b-link @click="onEditSub(type, 'editType', data.item)"><i class="ti-pencil-alt" style="font-size:20px;"></i></b-link>
            </b-col>
            <b-col sm="1">
              <b-link @click="onClickDeleteSub(type.id)"><i class="ti-trash" style="font-size:20px;"></i></b-link>
            </b-col>
          </b-row>
        </span>
      </template>
      <template v-slot:cell(action)="data">
        <span>
          <b-button variant="primary" size="sm" @click="onClickEdit(data.index)"
            >EDIT</b-button
          >&nbsp;&nbsp;&nbsp;
          <b-button
            variant="primary"
            size="sm"
            @click="onClickDelete(data.item.id)"
          >
            {{ data.value.id }}DELETE
          </b-button>
        </span>
      </template>
    </b-table>
    <b-pagination
      v-model="currentPage"
      :total-rows="rows"
      :per-page="perPage"
      aria-controls="my-table"
    ></b-pagination>

    <!-- POPUP DELETE -->

    <b-modal id="modal-delete" title="Delete Confirmation">
      <p>
        <b>Are you sure you want to delete ?</b>
      </p>
      <template v-slot:modal-footer="{ close }">
        <b-button variant="primary" size="sm" @click="close()">
          CLOSE
        </b-button>
        <b-button variant="danger" size="sm" @click="onClickDeleteConfirm">
          Delete
        </b-button>
      </template>
    </b-modal>

    <!-- POPUP DELETE -->
    <b-modal id="modal-delete-sub" title="Delete Confirmation">
      <p>
        <b>Are you sure you want to delete ?</b>
      </p>

      <template v-slot:modal-footer="{ close }">
        <b-button variant="primary" size="sm" @click="close()">
          CLOSE
        </b-button>
        <b-button variant="danger" size="sm" @click="deleteEditSub">
          Delete
        </b-button>
      </template>
    </b-modal>
  </b-card>
</template>

<script>
export default {
  data() {
    return {
      perPage: 10,
      currentPage: 1,
      filter: null,
      filterOn: [],
      totalRows: 1
    };
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => {
          return { text: f.label, value: f.key };
        });
    },
    rows() {
      return this.items.length;
    }
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.items.length;
  },
  props: {
    fields: {
      type: Array,
      required: true
    },
    items: {
      type: Array,
      required: true
    }
  },
  methods: {
    onClickDelete(id) {
      this.deleteIndex = id;
      this.$bvModal.show("modal-delete");
    },
    onClickDeleteConfirm() {
      const form = {
        outlet_id: this.deleteIndex
      };
      this.$store.dispatch("deleteOutlet", form).then(res => {
        if (res.data.response.code === 1) {
          this.$bvModal.hide("modal-delete");
          // this.getOutlet();
          this.$emit("delete", true);
        }
      });
    },
    onClickDeleteSub(id) {
      this.deleteIndex = id;
      this.$bvModal.show("modal-delete-sub");
    },
    deleteEditSub() {
      const form = {
        sub_outlet_id: this.deleteIndex
      };
      this.$store.dispatch("deleteSubOutlet", form).then(res => {
        if (res.data.response.code === 1) {
          this.$bvModal.hide("modal-delete-sub");
          this.$emit("delete", true);
        }
      });
    },
    getOutlet() {
      this.items = [];
      this.$store.dispatch("getOutlet").then(res => {
        if (res.data.response.code === 100) {
          let no = 0;
          res.data.data.forEach(element => {
            no = no + 1;
            let new_suboutlet = [];
            let typeoutlet = [];
            if (element.sub_outlet.length > 0 || element.sub_outlet !== undefined ) {
              element.sub_outlet.forEach(element2 => {
                new_suboutlet.push({
                  name: element2.name,
                  id: element2.sub_outlet_id
                });
              });
            }
            if (element.typeoutlet.length > 0 || element.typeoutlet !== undefined ) {
              element.typeoutlet.forEach(element3 => {
                typeoutlet.push({
                  name: element3.name,
                  outlet_id: element3.outlet_id,
                  id: element3.sub_outlet_id
                });
              });
            }

            this.items.push({
              no: no,
              name: element.name,
              id: element.outlet_id,
              suboutlet: new_suboutlet,
              typeoutlet: typeoutlet
            });
          });
          this.totalRows = this.items.length;
        }
      });
    },

    onClickEdit(index) {
      this.$emit("edit", index);
    },
    onEditSub(data,editData,allData) {
      data.editSubStatus = editData
      data.outlet = allData
      data.showData = true
      if (editData === "editSub") {
        data.title = "Sub Category Name"
      } else {
        data.title = "Outlet Category Type"
      }
      this.$emit("editSub", data);
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    }
  }
};
</script>
<style lang="css" scoped></style>
